interface InteractableModalProps {
  url: string
  onClose: () => void
}

export default function InteractableModal({ url, onClose }: InteractableModalProps) {
  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Keep the modal clear of the iOS notch, home indicator and the
        // dynamic Safari toolbars.
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
        boxSizing: 'border-box',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          width: '90vw',
          // dvh tracks the dynamic viewport so the modal shrinks when the
          // Safari toolbars are showing; the max caps it to the safe-area box.
          height: '90dvh',
          maxWidth: '100%',
          maxHeight: '100%',
          background: 'white',
          borderRadius: '8px',
          overflow: 'hidden',
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '0.5rem',
            right: '0.5rem',
            zIndex: 1,
            width: '2.5rem',
            height: '2.5rem',
            background: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            fontSize: '1.75rem',
            cursor: 'pointer',
          }}
        >×
        </button>
        <iframe
          src={url}
          title="Interactable content"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>
    </div>
  )
}
